import { render, staticRenderFns } from "./AddPackages.vue?vue&type=template&id=068cd2b9&"
import script from "./AddPackages.vue?vue&type=script&lang=js&"
export * from "./AddPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports